import React from "react";

import { useBotEmbed } from "./BotEmbedContext";
import BotWidget from "./BotWidget";
import PreviewSurface from "./PreviewSurface";
import TestSurface from "./TestSurface";
import { themeStylesFromConfig } from "./theme";
import useEmbeddedStyles from "./useEmbeddedStyles";

const BotEmbedScreen = ({
  mode,
  muiPortalContainer,
  shortCodeInput,
  setShortCodeInput,
  setSelectedBotId,
}) => {
  const { config } = useBotEmbed();
  const rootRef = useEmbeddedStyles();

  return (
    <div
      className={`bb-embed-root ${
        mode === "embed" ? "bb-embed-root--embed" : ""
      }`}
      ref={rootRef}
      style={themeStylesFromConfig(config)}
    >
      {mode === "preview" ? (
        <PreviewSurface />
      ) : mode === "test" ? (
        <TestSurface
          setSelectedBotId={setSelectedBotId}
          setShortCodeInput={setShortCodeInput}
          shortCodeInput={shortCodeInput}
        />
      ) : (
        <BotWidget muiPortalContainer={muiPortalContainer} />
      )}
    </div>
  );
};

export default BotEmbedScreen;
